/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/** Search AIFA-inspired catalog by name/active/AIC (min 2 chars). */
export const searchDrugs = async (q, limit = 15) =>
  (await api.get('/drugs/search', { params: { q, limit } })).data;

/** Ad-hoc interaction check for a list of drug names + optional patient. */
export const checkInteractions = async (drugs, patientId = null) =>
  (await api.post('/drugs/interactions/check', { drugs, patient_id: patientId })).data;

/** Interactions computed for a stored prescription. */
export const getPrescriptionInteractions = async (docId) =>
  (await api.get(`/fse/prescription/${docId}/interactions`)).data;

/** Request an OTP by email to sign the prescription. */
export const requestPrescriptionOtp = async (docId) =>
  (await api.post(`/fse/prescription/${docId}/otp`)).data;

/** Submit OTP → prescription becomes signed. */
export const signPrescription = async (docId, otp) =>
  (await api.post(`/fse/prescription/${docId}/sign`, { otp })).data;
